import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import router from "@/router";
import MainLayout from "@/layouts/MainLayout.vue";
import { useMeta } from "vue-meta";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose }) {
  expose();

useMeta({
  title: "",
  meta: [
    {
      property: "twitter:card",
      content: "summary",
    },
    {
      property: "twitter:title",
      content: "Colorado Sports Video",
    },
    {
      property: "twitter:description",
      content:
        "Get professional video recording services of your sports events",
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "og:title",
      content: "Colorado Sports Video",
    },
    {
      property: "og:description",
      content:
        "Get professional video recording services of your sports events",
    },
  ],
});

const layout = computed(() => {
  return router.currentRoute.value.meta.layout || MainLayout;
});

const __returned__ = { layout, computed, router, MainLayout, useMeta }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})